import React, { useEffect, useState } from "react";
import Layout from "../../components/shared/Layout/Layout";
import API from "../../services/API";
import momemt  from 'moment';
const Donar = () => {
  const [data, setData] = useState([]);
  //find the donar records
  const getDonar = async () => {
    try {
      const { data } = await API.get("/inventory/get-donar");
      if(data?.success)
      {
        setData(data?.donar);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getDonar();
  }, []);

  return (
    <Layout>
              <table className="table">
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">EmailID</th>
                  <th scope="col">Phone</th>
                  <th scope="col">Date</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((record) => (
                  <tr key={record._id}>
                    <td>{record.name || record.organisationName + " (ORG)"}</td>
                    <td>{record.email}</td>
                    <td>{record.phone}</td>

                    <td>
                      {momemt(record.createdAt).format("DD/MM/YYYY hh:mm A")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
    </Layout>
  );
};

export default Donar;
